/**
 * Color palette based on brand colors
 * No animations or transitions - admin dashboard focused
 */

export const palette = {
  // Brand Primary (Cyan/Turquoise)
  brand: {
    50: '#E0F7FA',
    100: '#CFF2F7',
    200: '#B2E8F0',
    300: '#94DDE8',
    400: '#67CFDB',
    500: '#3BC1CF', // Base primary
    600: '#2F9AA6',
    700: '#23747C',
    800: '#184D53',
    900: '#0C2729',
  },

  // Brand Secondary (Blue)
  brandSecondary: {
    50: '#E0EFF9',
    100: '#C7E5F5',
    200: '#9ED1EE',
    300: '#74BCE6',
    400: '#4798D1',
    500: '#1974BB', // Base secondary
    600: '#145D96',
    700: '#0F4670',
    800: '#0A2E4B',
    900: '#051725',
  },

  // Status colors
  status: {
    success: '#10B981',
    successDark: '#059669',
    warning: '#F59E0B',
    warningDark: '#D97706',
    danger: '#EF4444',
    dangerDark: '#DC2626',
    info: '#0EA5E9',
    infoDark: '#0284C7',
  },

  // Light mode
  light: {
    background: '#F7FBFE',
    foreground: '#1E293B',
    card: '#FEFEFE',
    cardForeground: '#1E293B',
    muted: '#F1F5F9',
    mutedForeground: '#64748B',
    border: '#E2E8F0',
    input: '#F8FAFC',
  },

  // Dark mode
  dark: {
    background: '#0F172A',
    foreground: '#F8FAFC',
    card: '#1E293B',
    cardForeground: '#F8FAFC',
    muted: '#334155',
    mutedForeground: '#94A3B8',
    border: '#334155',
    input: '#334155',
  },

  // Sidebar
  sidebar: {
    light: {
      background: '#E0F7FE',
      foreground: '#1E293B',
      border: '#CBD5E1',
    },
    dark: {
      background: '#0F172A',
      foreground: '#FFFFFF',
      border: '#1E293B',
    },
  },

  // Chart colors
  chart: {
    1: '#3BC1CF',
    2: '#1974BB',
    3: '#10B981',
    4: '#F59E0B',
    5: '#EF4444',
  },
} as const;

export type PaletteType = typeof palette;

